<template>
  <el-dialog
    title="异常声纹信息"
    :visible.sync="visible"
    @opened="openDialog"
    class="temperatureDialog"
    @close="closeDialog"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :class="visible ? 'flip-in-hor-bottom' : ''"
  >
    <div>
      <div>
     
      </div>
    </div>
  </el-dialog>
</template>

<script>
import commonUtils from "@/utils/common";
import datePicker from "@/components/datePicker.vue";
import Pagination from "@/components/Pagination.vue";
export default {
  components: { datePicker, Pagination },
  data() {
    return {
      activeTab: "表格1", // 当前选中的选项卡
      activeStep: 0,
      visible: false,
      lineChartDataX: [],
      lineChartDataY: [],
      lightedPoint: [],
      form1: {
        uuid: "",
        frp: "",
        remark: "",
        
      },
      rules: {
        uuid: [
          { required: true, message: "机器码不能为空", trigger: "blur" },
        ],
        // frp: [
        //   { required: true, message: "电梯名称不能为空", trigger: "blur" },
        // ],
       
      },
      value1: new Date(),
      maxTime: commonUtils.timeFormat(new Date()),
      minTime: commonUtils.timeFormat(
        new Date(new Date().getTime() - 3600 * 24 * 1000)
      ),
      dateValue: [
        commonUtils.timeFormat(
          new Date(new Date().getTime() - 3600 * 24 * 1000)
        ),
        commonUtils.timeFormat(new Date()),
      ],
      options: [
        {
          value: "1",
          label: "重要",
        },
        {
          value: "2",
          label: "不重要",
        },
      ],
      TypeOptions: [
        {
          value: "elevator",
          label: "直梯",
        },
        {
          value: "escalator",
          label: "扶梯",
        },
        {
          value: "cargo",
          label: "货梯",
        },
      ],
      total: 100,
      pageNo: 1,
      pageSize: 10,
    };
  },
  methods: {
   
    openDialog() {},
    closeDialog() {
      this.visible = false;
    },
   
  },
};
</script>

<style lang="less" scoped>
.temperatureDialog {
  /deep/ .el-dialog__title {
 font-size: 1.5rem;
  }
  /deep/ .el-input__inner {
    border: 1px solid #c0e9ff1f;
    background: var(--input-bg);
    color: var(--titleName-color);
    border-radius: 0px;
  }
    /deep/ .el-form-item__label {
    font-size: 0.875rem;
  }

//   /deep/ .el-select {
//     width: 215px;
//   }
//   /deep/ .el-select-dropdown__wrap.el-scrollbar__wrap {
//     overflow: auto;
//     background-color: #244447;
//     border: none;
//   }
//   /deep/ .el-select-dropdown {
//     border: none;
//   }
//   /deep/ .el-select-dropdown__item.hover,
//   .el-select-dropdown__item:hover {
//     color: #d3fbff;
//     background-color: #3f98a0;
//   }

//   /deep/ .el-select-dropdown__item.selected {
//     color: #d3fbff;
//   }
//   /deep/ .el-select-dropdown__item {
//     color: rgba(255, 255, 255, 0.603);
//   }



//   /deep/.el-dialog__body {
//     // padding: 25px 20px !important;
//     color: #ffffff;
//     background: #182732;
//   }

//   /deep/ .el-dialog {
//     background: #344142ec;
//     width: 55rem;
//     // height: 43.75rem;
//   }


//   /deep/ .pagination-container {
//     text-align: center;
//   }
//   /deep/ .el-textarea__inner {
//     width: 31.25rem;
//     height: 8rem;
//     color: white;
//     border-radius: 0.25rem;
//     border: 0.1875rem solid #c0e9ff1f;
//     background: #24444757;
//     border-radius: 0px;
//     font-size: 0.875rem;
//   }
//   /deep/ .el-textarea__inner:focus {
//     border-color: #55b1b1 !important;
//   }
}


//添加动画
.flip-in-hor-bottom {
  animation: flip-in-hor-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes flip-in-hor-bottom {
  0% {
    transform: rotateX(80deg);
    opacity: 0;
  }

  100% {
    transform: rotateX(0);
    opacity: 1;
  }
}

.btn3 {
  width: 8.125rem;
  height: 1.875rem;
  background: #219E82;
  border-radius: 0.125rem;
  border: 0.0625rem solid #219E82;
  color: white;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn3:hover {
  background: #44D7B6;
}
.btn4 {
  width: 8.125rem;
  height: 1.875rem;
  border-radius: 0.125rem;
  border: 0.0625rem solid #44D7B6;
  background: transparent;
  color: #44D7B6;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn4:hover {
  background: #44D7B655;
}
.pane-title {
  padding-left: 30px;
  font-size: 21px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #5bb3bc;
  line-height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/pages/home/warnSearch/dialog/audioDialog.vue